import clsx from "clsx";
import { memo } from "react";

const Loading = memo(({ height = "40px", color = "green" }: { height?: string; color?: "red" | "green" | "white" }) => {
  return (
    <svg className="loading" width={height} height={height} viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
      <circle
        className={clsx(
          color === "green" && "path-green",
          color === "red" && "path-red",
          color === "white" && "path-green"
        )}
        fill="none"
        strokeWidth="10"
        strokeLinecap="round"
        cx="33"
        cy="33"
        r="27"
      ></circle>
    </svg>
  );
});

Loading.displayName = "Loading";

export default Loading;
